import { useTranslation } from 'react-i18next';
import { FileText, Mic, Video, type LucideIcon } from 'lucide-react';
import { Card } from '@/components/ui/atoms/Card';
import { Typography } from '@/components/ui/atoms/Typography';
import { OverviewIconBadge } from './OverviewIconBadge';

const TIP_CONFIG = [
  { id: 'tip-1', icon: FileText, categoryKey: 'prep_tips.tip-1.category', contentKey: 'prep_tips.tip-1.content' },
  { id: 'tip-2', icon: Video, categoryKey: 'prep_tips.tip-2.category', contentKey: 'prep_tips.tip-2.content' },
  { id: 'tip-3', icon: Mic, categoryKey: 'prep_tips.tip-3.category', contentKey: 'prep_tips.tip-3.content' },
] as const satisfies ReadonlyArray<{
  id: string;
  icon: LucideIcon;
  categoryKey: string;
  contentKey: string;
}>;

/** Compact tip cards: icon + title on one row, description below. */
export const InterviewPreparationTips = () => {
  const { t } = useTranslation('interview');

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-stretch">
      {TIP_CONFIG.map(({ id, icon, categoryKey, contentKey }) => (
        <Card
          key={id}
          variant="custom"
          padding="md"
          rounded="xl"
          className="!m-0 flex flex-col gap-2.5 border border-light-lila/60 bg-light"
        >
          <div className="flex items-center gap-3">
            <OverviewIconBadge icon={icon} />
            <Typography as="h4" variant="h5" color="primary">
              {t(categoryKey)}
            </Typography>
          </div>
          <Typography as="p" variant="body-sm" color="secondary">
            {t(contentKey)}
          </Typography>
        </Card>
      ))}
    </div>
  );
};
